import { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router";
import VideoBox from "../../casinoComponents/videoBox";
import CasinoLastResult from "../../casinoComponents/casinoLastResult";
import MyBet from "../../casinoComponents/myBet";
import CasinoTableLayout from "../../casinoComponents/casinoTableLayout";
import { getCasinoGameDetails, getCasinoOpenBets } from "../../../apiservices/CasionApi";
import ViewMoreModal from "../../../components/ViewMoreModal";
import { extractCasinoGame } from "../../../utils/casinoGame";
import { isAb50BetDecided } from "../../../utils/casinoMyBets";
import { IS_REF_MOBILE } from "../../../utils/refViewport";
import AbVideoCards from "./AbVideoCards";
import AbBetTable from "./AbBetTable";
import RRefResults from "./RRefResults";
import Ab3ResultBody from "../../casinoComponents/refResultModal/Ab3ResultBody";
import "../../../styles/games/andarbahar.css";

// Reference title (lastresults2 res1.cname)
const AB_TITLES = {
  ab3: "ANDAR BAHAR 50 CARDS",
  ab4: "ANDAR BAHAR 150 CARDS",
};

export default function AndarBahar34() {
  const [gameData, setGameData] = useState(null);
  const [myBets, setMyBets] = useState([]);
  const [showViewMoreModal, setShowViewMoreModal] = useState(false);

  const { pathname } = useLocation();
  const gameName = extractCasinoGame(pathname);
  const iframeSrc = `https://stream-s-43.uhdmovies.online/casino-stream?id=${gameName}`;

  useEffect(() => {
    const gameName = extractCasinoGame(pathname);
    const fetchGameData = async () => {
      try {
        const response = await getCasinoGameDetails(gameName);
        setGameData(response);
      } catch (err) {
        console.error("API Fetch Error:", err.message);
        setGameData(null); // clear data on error
      }
    };

    fetchGameData();
    const interval = setInterval(fetchGameData, 1500);
    return () => clearInterval(interval);
  }, [pathname]);

  const subData = gameData?.data?.data?.sub || [];

  // My Bets: same API as lord-admin – GET /lords/bet-list/casino/open-downline?gameName=...
  const fetchMyBetsData = useCallback(async () => {
    const gameName = extractCasinoGame(pathname);
    if (!gameName) return;
    try {
      const response = await getCasinoOpenBets(gameName);
      if (response?.success && Array.isArray(response.data)) {
        const formattedBets = response.data.map((bet) => ({
          // My Bets "Gametype" column (casino_bets.game_name, e.g. mogambo)
          description: bet.description ?? bet.game_name ?? bet.gameName,
          userName: bet.username || bet.userName || "-",
          matchedBet: bet.matchedBet || bet.nation || bet.selection || bet.player_name || "-",
          selection: bet.selection || bet.player_name || bet.matchedBet || "",
          player_name: bet.player_name || "",
          odds: bet.odds ?? bet.userrate ?? "0",
          stake: bet.stake ?? bet.amount ?? "0",
          placeDate: bet.placeDate ?? bet.created_at ?? "-",
          gametype: bet.gametype ?? bet.game_type ?? (bet.type === "lay" ? "Lay" : bet.type === "back" ? "Back" : "-"),
          type: bet.type || null,
          exposer: parseFloat(bet.exposer || bet.exposure_amount || "0") || 0
        }));
        setMyBets(formattedBets);
      }
    } catch (error) {
      console.error("Error fetching my bets (open-downline):", error);
    }
  }, [pathname]);

  const handleBetClick = (value) => {
    if (!value) return;
    fetchMyBetsData();
  };

  // My Bets every 3s like lord-admin
  useEffect(() => {
    fetchMyBetsData();
    const intervalId = setInterval(fetchMyBetsData, 3000);
    return () => clearInterval(intervalId);
  }, [fetchMyBetsData]);

  const feed = gameData?.data?.data ?? {};
  const mid = feed?.mid || gameData?.data?.mid || "";
  const title = AB_TITLES[gameName] || "";
  // ab3 settles card by card: a bet leaves the list once its deciding card is dealt.
  const shownBets = gameName === "ab3" && feed?.card ? myBets.filter((b) => !isAb50BetDecided(b, feed.card)) : myBets;
  // My Bets / View More: the bet's name with its deal position ("Andar Q/7", player_name)
  const formatNation = (nat, bet) => bet?.player_name || nat;

  // Reference page (casino-table.andar-bahar2.ab3, used for both ab3 and ab4): title + Round ID inside
  // the video, Andar/Bahar card sliders (in the video ≥1280 at load, else at the top of .casino-detail),
  // .ab-bg bet area once the feed has a round, remark, Last Result.
  return (
    <CasinoTableLayout
      tableClass="andar-bahar2 ab3"
      rightSide={<MyBet bets={shownBets} onViewMore={() => setShowViewMoreModal(true)} formatNation={formatNation} />}
    >
      <>
        <VideoBox
          iframeSrc={iframeSrc}
          timerValue={feed?.lt}
          gameType={gameName}
          titleNode={
            <div className="casino-video-title">
              <span className="casino-name">{title}</span>{" "}
              <div className="casino-video-rid">Round ID: {mid}</div>
            </div>
          }
          cardsOverlay={IS_REF_MOBILE ? null : <AbVideoCards cardString={feed?.card} variant="video" />}
        />{" "}
        <div className="casino-detail">
          {IS_REF_MOBILE ? <AbVideoCards cardString={feed?.card} variant="detail" /> : null}{" "}
          {mid ? (
            <AbBetTable
              gameType={gameName}
              child={feed?.child}
              sub={subData}
              onBetClick={handleBetClick}
            />
          ) : null}{" "}
          {feed?.remark ? (
            <div className="casino-remark mt-1">
              <div className="remark-icon">
                <img src={`${import.meta.env.BASE_URL}assets/img/icons/remark.png`} alt="" />
              </div>{" "}
              <marquee>{feed.remark}</marquee>
            </div>
          ) : null}{" "}
          <CasinoLastResult
            gameType={gameName}
            gameData={gameData}
            resultComponent={
              <RRefResults
                gameType={gameName}
                mid={mid}
                fallbackTitle={title}
                renderBody={(t1) => <Ab3ResultBody t1={t1} />}
              />
            }
          />
        </div>
      </>
      <ViewMoreModal
        show={showViewMoreModal}
        onHide={() => setShowViewMoreModal(false)}
        title="View More"
        sectionKey={gameName}
        formatNation={formatNation}
      />
    </CasinoTableLayout>
  );
}
